// Embaralhar produtos aleatoriamente a cada visita
document.addEventListener('DOMContentLoaded', function() {
  
  // Função para embaralhar array (Fisher-Yates shuffle)
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  
  // Encontrar todas as grids de produtos
  const productGrids = document.querySelectorAll('.product-grid, .collection-grid, .grid--peek');
  
  productGrids.forEach(function(grid) {
    // Pegar todos os items do grid
    const items = Array.from(grid.children);
    
    // Embaralhar os items
    const shuffledItems = shuffleArray(items);
    
    // Limpar o grid
    grid.innerHTML = '';
    
    // Adicionar items embaralhados de volta
    shuffledItems.forEach(function(item) {
      grid.appendChild(item);
    });
  });
  
  console.log('✅ Produtos embaralhados aleatoriamente!');
});